import { render, staticRenderFns } from "./AdditionMain.vue?vue&type=template&id=53583722&"
import script from "./AdditionMain.vue?vue&type=script&lang=ts&"
export * from "./AdditionMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports